module.exports = __webpack_public_path__ + "static/img/renmingyoudian.a5c5ec2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ggw_img/renmingyoudian.png
// module id = QyiB
// module chunks = 36